<script setup lang="ts">
  import { registerSW } from '@uplatform-ai/vite-plugin-version-worker/client'

  import { UButton } from '@/shared/ui/components'

  const promptIsVisible = ref(false)
  const showPrompt = () => {
    promptIsVisible.value = true
  }

  const hidePrompt = () => {
    promptIsVisible.value = false
  }

  const { refreshApp } = registerSW({
    onUpdate: (versionInfo, previousVersionInfo) => {
      const hasChanged = versionInfo.gitCommit !== previousVersionInfo.gitCommit
      if (hasChanged) {
        showPrompt()
      }
    },
    workerPath: '/versionWorkerV2.js',
  })
</script>

<template>
  <div
    v-if="promptIsVisible"
    class="fixed top-5 right-5 z-100 flex w-full max-w-[350px] flex-col gap-2 rounded-lg border border-gray-300 bg-white p-5"
  >
    <div class="flex flex-col gap-1">
      <div class="text-lg font-semibold">{{ $t('update_page_prompt_title') }}</div>
      <div class="text-sm font-medium">{{ $t('update_page_prompt_description') }}</div>
    </div>
    <div class="mt-2 flex gap-2">
      <UButton
        type="primary"
        @click="refreshApp"
      >
        {{ $t('update_page_prompt_button') }}
      </UButton>
      <UButton
        type="secondary"
        @click="hidePrompt"
      >
        {{ $t('update_page_prompt_close') }}
      </UButton>
    </div>
  </div>
</template>
